/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

export const gtmEventTypes = {
  FED_BUILDTOOL_002: 'FED_BUILDTOOL_002',
  BUILDTOOL_LOAD_CONFIG: 'FED-BUILDTOOL-003',
  BUILDTOOL_STEP_BODY_CHANGE: 'FED-BUILDTOOL-004',
  BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON: 'FED-BUILDTOOL-005',
  BUILDTOOL_CLICKED_SIDE_NAV: 'FED-BUILDTOOL-006',
  BUILDTOOL_STEP_DRIVE_CHANGE: 'FED-BUILDTOOL-007',
  BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON: 'FED-BUILDTOOL-008',
  BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON: 'FED-BUILDTOOL-009',
  BUILDTOOL_STEP_GRADE_CHANGE: 'FED-BUILDTOOL-010',
  BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON: 'FED-BUILDTOOL-011',
  BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON: 'FED-BUILDTOOL-012',
  BUILDTOOL_STEP_COLOR_CHANGE: 'FED-BUILDTOOL-013',
  BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR: 'FED-BUILDTOOL-014',
  BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR: 'FED-BUILDTOOL-015',
  BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS: 'FED-BUILDTOOL-016',
  BUILDTOOL_STEP_COLOR_CLICKED_NEXT: 'FED-BUILDTOOL-017',
  BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS: 'FED-BUILDTOOL-018',
  BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE: 'FED-BUILDTOOL-019',
  BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON: 'FED-BUILDTOOL-020',
  BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS: 'FED-BUILDTOOL-021',
  FED_BUILDTOOL_022: 'FED-BUILDTOOL-022',
  FED_BUILDTOOL_023: 'FED-BUILDTOOL-023',
  FED_BUILDTOOL_024: 'FED-BUILDTOOL-024',
  BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST: 'FED-BUILDTOOL-025',
  BUILDTOOL_CLICKED_PRICE_DISCLAIMER: 'FED-BUILDTOOL-026',
  BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER: 'FED-BUILDTOOL-027',
  BUILDTOOL_CLICKED_SAVE: 'FED-BUILDTOOL-028',
  BUILDTOOL_SEND_SAVE_FORM: 'FED-BUILDTOOL-029',
  BUILDTOOL_CLICKED_COPY_URL: 'FED-BUILDTOOL-030',
  BUILDTOOL_CLICKED_SHARE: 'FED-BUILDTOOL-031',
  BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT: 'FED-BUILDTOOL-032',
  BUILDTOOL_SEND_SHARE_FORM: 'FED-BUILDTOOL-033',
}

// Action creators -> EventsMap
export const gtmEvents = {
  [gtmEventTypes.BUILDTOOL_LOAD_CONFIG]: ({
                                            modelName = '',
                                            stepNumber = '',
                                            stepName = '',
                                            bodyName = '',
                                            driveName = '',
                                            gradeName = '',
                                            colorName = '',
                                            interiorName = '',
                                          }) => ({
    type: gtmEventTypes.BUILDTOOL_LOAD_CONFIG,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_LOAD_CONFIG,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} ${stepName} - "${bodyName}" - "${driveName}" - "${gradeName}" - "${colorName}" - "${interiorName}"`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV]: ({
                                                 modelName = '',
                                                 stepNumber = '',
                                                 stepName = '',
                                                 newStepName = '',
                                               }) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SIDE_NAV,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" Step ${stepNumber} ${stepName} - Clicked side step nav "${newStepName}"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE]: ({
                                                 modelName = '',
                                                 stepNumber = '',
                                                 bodyName = '',
                                               }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_BODY_CHANGE,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" Step ${stepNumber} BODY - Clicked "${bodyName}"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON]: ({
                                                              modelName = '',
                                                              stepNumber = '',
                                                            }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_BODY_CLICKED_NEXT_BUTTON,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} BODY - Clicked "NEXT STEP"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE]: ({
                                                  modelName = '',
                                                  stepNumber = '',
                                                  driveName = '',
                                                }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CHANGE,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} DRIVE - Clicked drive"${driveName}"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON]: ({
                                                                   modelName = '',
                                                                   stepNumber = '',
                                                                 }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_PREVIOUS_BUTTON,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} DRIVE - Clicked "PREVIOUS"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON]: ({
                                                               modelName = '',
                                                               stepNumber = '',
                                                             }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_DRIVE_CLICKED_NEXT_BUTTON,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} DRIVE - Clicked "NEXT STEP"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE]: ({
                                                  modelName = '',
                                                  stepNumber = '',
                                                  gradeName = '',
                                                }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CHANGE,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} GRADE - Clicked grade "${gradeName}"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON]: ({
                                                               modelName = '',
                                                               stepNumber = '',
                                                             }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLICKED_NEXT_BUTTON,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} GRADE - Clicked "NEXT STEP"	"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON]: ({
                                                                    modelName = '',
                                                                    stepNumber = '',
                                                                  }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_GRADE_CLIECKED_PREVIOUS_BUTTON,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} GRADE - Clicked "PREVIOUS"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE]: ({
                                                  modelName = '',
                                                  stepNumber = '',
                                                  colorName = '',
                                                }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} COLOUR - Clicked "${colorName}"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR]: ({
                                                            modelName = '',
                                                            stepNumber = '',
                                                            typeName = '',
                                                          }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_INTERIOR,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} COLOUR - Clicked "${typeName}"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR]: ({
                                                           modelName = '',
                                                           stepNumber = '',
                                                           interiorName = '',
                                                         }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CHANGE_INTERIOR,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} INTERIOR COLOUR - Clicked "${interiorName}"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS]: ({modelName = '', stepNumber = ''}) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_PREVIOUS,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} COLOUR - Clicked "PREVIOUS"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT]: ({modelName = '', stepNumber = ''}) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_COLOR_CLICKED_NEXT,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} COLOUR - Clicked "NEXT STEP"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS]: ({
                                                              modelName = '',
                                                              stepNumber = '',
                                                            }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_PREVIOUS,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} SUMMARY - Clicked "PREVIOUS"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE]: ({
                                                                       modelName = '',
                                                                       stepNumber = '',
                                                                     }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_BOOK_A_TEST_DRIVE,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} SUMMARY - Clicked "BOOK A TEST DRIVE"`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON]: ({
                                                                 modelName = '',
                                                                 stepNumber = '',
                                                                 newStepNumber,
                                                               }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_CLICKED_EDIT_BUTTON,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} SUMMARY - Clicked "EDIT SUMMARY ITEM STEP ${newStepNumber}"	`,
  }),
  [gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS]: ({
                                                                           modelName = '',
                                                                           stepNumber = '',
                                                                           newStatusName = '',
                                                                         }) => ({
    type: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_STEP_SUMMARY_TOGGLE_FEATURE_SPECIFICATIONS,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} SUMMARY - ${newStatusName}`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER]: ({
                                                                         modelName = '',
                                                                         stepNumber = '',
                                                                       }) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_FEATURE_SPECIFICATION_DISCLAIMER,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} SUMMARY - Clicked "FEATURE SPECS DISCLAIMER"`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST]: ({
                                                                modelName = '',
                                                                stepNumber = '',
                                                              }) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_FULL_SPECIFICATION_LIST,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} SUMMARY - Clicked "EXPLORE FULL ${modelName} SPECIFICATION"`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER]: ({
                                                         modelName = '',
                                                         stepNumber = '',
                                                         stepName = '',
                                                       }) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_PRICE_DISCLAIMER,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}" - Step ${stepNumber} ${stepName} - Clicked "PRICE DISCLAIMER"`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_SAVE]: ({
                                             modelName = '',
                                             stepNumber = '',
                                             stepName = '',
                                             bodyName = '',
                                             driveName = '',
                                             gradeName = '',
                                             colorName = '',
                                             interiorName = '',
                                           }) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_SAVE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SAVE,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}", "${bodyName}", "${driveName}", "${gradeName}", "${colorName}", "${interiorName}" - Step "${stepNumber} ${stepName}" - Clicked "SAVE"`,
  }),
  [gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM]: ({
                                               modelName = '',
                                               stepNumber = '',
                                               stepName = '',
                                               bodyName = '',
                                               driveName = '',
                                               gradeName = '',
                                               colorName = '',
                                               interiorName = '',
                                             }) => ({
    type: gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_SEND_SAVE_FORM,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}", "${bodyName}", "${driveName}", "${gradeName}", "${colorName}", "${interiorName}" - Step "${stepNumber} ${stepName}" - Clicked "SEND"`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL]: ({
                                                 modelName = '',
                                                 stepNumber = '',
                                                 stepName = '',
                                                 bodyName = '',
                                                 driveName = '',
                                                 gradeName = '',
                                                 colorName = '',
                                                 interiorName = '',
                                               }) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_COPY_URL,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}", "${bodyName}", "${driveName}", "${gradeName}", "${colorName}", "${interiorName}" - Step "${stepNumber} ${stepName}" - Clicked "COPY URL"`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_SHARE]: ({
                                              modelName = '',
                                              stepNumber = '',
                                              stepName = '',
                                              bodyName = '',
                                              driveName = '',
                                              gradeName = '',
                                              colorName = '',
                                              interiorName = '',
                                            }) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_SHARE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_SHARE,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build "${modelName}", "${bodyName}", "${driveName}", "${gradeName}", "${colorName}", "${interiorName}" - Step "${stepNumber} ${stepName}" - Clicked "SHARE"`,
  }),
  [gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT]: ({modelName = ''}) => ({
    type: gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_CLICKED_ADD_ANOTHER_RECIPIENT,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build Share "${modelName}", Share - Clicked "Add another recipient"
`,
  }),
  [gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM]: ({
                                                modelName = '',
                                                stepNumber = '',
                                                stepName = '',
                                                bodyName = '',
                                                driveName = '',
                                                gradeName = '',
                                                colorName = '',
                                                interiorName = '',
                                              }) => ({
    type: gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BUILDTOOL_SEND_SHARE_FORM,
    pageCategory: `Build Tool "${modelName}"`,
    pageAction: `Build Share "${modelName}", "${bodyName}", "${driveName}", "${gradeName}", "${colorName}", "${interiorName}" - Step "${stepNumber} ${stepName}" - Clicked "SEND"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/build-duck.js